export const exposeExperimentToNewRelic = (experimentName: TExperimentName, segment: TExperimentSegment): void => {
    if (typeof newrelic === 'undefined' || window.newrelic === undefined) {
        return
    }

    newrelic.setCustomAttribute(`experiment_${experimentName}`, segment)
}
